import PropTypes from 'prop-types';
import { noop } from 'lodash';

export const propTypes = {
    isOpen: PropTypes.bool,
    onBeforeOpen: PropTypes.func,
    onOpen: PropTypes.func,
    onBeforeClose: PropTypes.func,
    onClose: PropTypes.func,
    innerRef: PropTypes.ref(),
};

export const defaultProps = {
    isOpen: false,
    onBeforeOpen: noop,
    onOpen: noop,
    onBeforeClose: noop,
    onClose: noop,
    innerRef: null,
};
